const featurebaseRepository = (fetch: CustomFetch) => ({
  async getSsoToken(payload: {
    name: string
    email: string
    userId: string
    companies?: Array<{ id: string; name: string }>
  }) {
    return await fetch<{ token: string }>('/v1/featurebase/sso-token', {
      method: 'POST',
      body: payload,
    })
  },
})

export default featurebaseRepository
